import { createContext, useContext, useState, ReactNode } from 'react';

interface User {
  id: string;
  name: string;
  email: string;
  isAuthenticated: boolean;
}

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  updateUserName: (name: string) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

interface UserProviderProps {
  children: ReactNode;
}

export const UserProvider = ({ children }: UserProviderProps) => {
  // Mock user data - replace with real authentication later
  const [user, setUser] = useState<User | null>({
    id: '1',
    name: 'Beautiful Soul',
    email: 'user@example.com',
    isAuthenticated: true
  });

  const updateUserName = (name: string) => {
    if (user) {
      setUser({ ...user, name });
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser, updateUserName }}>
      {children}
    </UserContext.Provider>
  );
};